import classNames from "classnames";
import type { FC } from "react";
import { changeFilter } from "../../../../filters/ngFilters";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const ChangePercentageDashboard: FC<ITableCellProps> = ({ value }) => {
    const classes = classNames("changePercentageDashboard", {
        negative: value < 0,
        positive: value > 0,
    });
    const iconClasses = classNames("changePercentage-icon", {
        "sw-icon-arrow-up5": value > 0,
        "sw-icon-arrow-down5": value < 0,
    });
    return (
        <div className={classes}>
            <i className={iconClasses} /> {changeFilter()(Math.abs(value), undefined)}
        </div>
    );
};
ChangePercentageDashboard.displayName = "ChangePercentageDashboard";
